import { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import styles from "./css/registerDialog.module.css";
import { IoIosCloseCircle } from "react-icons/io";
import BoxAlert from "../../../../components/boxAlert/index.jsx";
import { registerCommissionedAgent } from "../../services/registerCommissionedAgent.js";
import { updateCommissionedAgent } from "../../services/updateCommissionedAgent.js";
import { InputMask } from "@react-input/mask";


export default function RegisterDialog({ view, onClose, onReturn, agent }) {

    // VARIÁVEIS DE EDIÇÃO ===============================>

    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [notes, setNotes] = useState('');

    const [checkActive, setCheckActive] = useState(true);


    // LOADING CONTROLLER
    const [loading, setLoading] = useState(false);


    // ALERTS CONTROLLER
    const [warnAlert, setWarnAlert] = useState({ show: false, title: null, text: null });




    // FUNCTIONS ===========================>

    useEffect(() => {
        if (agent) {
            setName(agent?.name ?? '');
            setPhone(agent?.phone ?? '');
            setEmail(agent?.email ?? '');
            setNotes(agent?.notes ?? '');
            setCheckActive(agent?.status ?? true);

        } else {
            setName('');
            setPhone('');
            setEmail('');
            setNotes('');
            setCheckActive(true);
        }
    }, [view, agent])



    // FUNÇÃO QUE SALVA OS DADOS DO COMISSIONADO
    const handleSaveData = async () => {
        try {
            setLoading(true);

            // Valida os dados do formulário
            if (!name) {
                setWarnAlert({ show: true, title: 'Alerta', text: 'Insira um nome válido para continuar!' });
                return;
            }

            const data = {
                name: name,
                phone: phone || null,
                email: email || null,
                notes: notes || null,
            }

            if (agent && agent?.id) {
                data.id = agent?.id;
                data.status = checkActive;

                await updateCommissionedAgent({ data });

            } else {
                await registerCommissionedAgent({ data });
            }

            onReturn();

        } catch (e) {
            console.error('ERROR - SAVE COMMISSIONED AGENT DATA FUNCTION:', e);
            setWarnAlert({ show: true, title: 'Erro', text: e?.response?.data?.error || 'Houve um erro ao salvar os dados do comissionado. Tente novamente em instantes!' });

        } finally {
            setLoading(false);
        }
    }




    // COMPONENT ===================================================>

    return view && (
        <div id={styles.editInformationsArea}>

            <div className={styles.editInformationsOverflow} />

            <div className={styles.editBox}>

                {/* BOX HEADER */}
                <div className={styles.editBoxHeader}>

                    <div className={styles.boxHeaderContainer}>
                        <h1 className={styles.titleBox}>{agent ? agent?.name : 'Registrar comissionado'}</h1>

                        <button className={styles.closeBtn} onClick={() => onClose()}>
                            <IoIosCloseCircle size={30} color='#fff' />
                        </button>

                    </div>
                </div>



                {/* BOX CONTAINER AREA */}

                <div id={styles.boxContainer}>

                    <div className={styles.form}>

                        <div className={styles.formArea}>

                            <p className={styles.titleInformations} style={{ marginBottom: 0 }}>Dados do comissionado:</p>

                            <div className={styles.rowInputsArea}>
                                <div className={styles.inputAreaConfig}>
                                    <label className={styles.labelInput}>Nome: *</label>
                                    <input className={styles.inputConfig} type="text" value={name} onChange={(event) => setName(event.target.value)} placeholder='Nome' />
                                </div>

                                <div className={styles.inputAreaConfig}>
                                    <label className={styles.labelInput}>Telefone:</label>
                                    <InputMask
                                        className={styles.inputConfig}
                                        mask={phone.replace('(', '').replace(')', '').replace('-', '').length < 11 ? "(__) ____-____)" : "(__) _____-____)"}
                                        replacement={{ _: /\d/ }}
                                        placeholder={'(99) 99999-9999'}
                                        value={phone}
                                        onChange={({ target: { value } }) => setPhone(value)}
                                    />
                                </div>
                            </div>

                            <div className={styles.rowInputsArea}>
                                <div className={styles.inputAreaConfig}>
                                    <label className={styles.labelInput}>Email:</label>
                                    <input className={styles.inputConfig} type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder='Email' />
                                </div>

                                <div className={styles.inputAreaConfig}>
                                    <label className={styles.labelInput}>Observações:</label>
                                    <input className={styles.inputConfig} type="text" value={notes} onChange={(event) => setNotes(event.target.value)} placeholder='Observações' />
                                </div>
                            </div>

                        </div>

                        {agent && (
                            <div className={styles.formArea}>
                                <div className={styles.checkboxArea}>
                                    <p className='labelCheckbox'>Ativo:</p>
                                    <input type='checkbox' className={styles.checkboxConfig} checked={checkActive} onChange={() => setCheckActive(!checkActive)} />
                                </div>
                            </div>
                        )}

                    </div>

                    <div className={styles.editButtonsArea}>
                        <button id={styles.saveDataButton} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => handleSaveData()}>
                            {loading ? (
                                <Oval
                                    visible={true}
                                    height="20"
                                    width="20"
                                    color="#fff"
                                    ariaLabel="oval-loading"
                                />
                            ) : (
                                <p id={styles.saveDataBtnText}>Salvar</p>
                            )}
                        </button>
                    </div>

                </div>

            </div>


            <BoxAlert
                show={warnAlert.show}
                title={warnAlert.title}
                text={warnAlert.text}
                confirmFunction={() => setWarnAlert({ show: false, title: null, text: null })}
            />

        </div>

    )
}
